<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flex-spc-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="postion:fixed">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>照片墙</el-breadcrumb-item>
      </el-breadcrumb>
      <el-link type="primary" style="margin-right:220px" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
    </div>
       <el-form :inline="true" :model="formInline" class=" flex-r-x" style="width:100%;padding-top:30px">
         <el-button size="mini" type="primary" icon="el-icon-plus" @click="addShowImgClick()">添加照片墙</el-button>
      </el-form>
    <el-table  :data="tableData" highlight-current-row v-loading="loading"  size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
    <el-table-column label="图片标题" prop="ImgTitle"></el-table-column>
      <el-table-column align="center" label="操作" width="250" >
        <template slot-scope="scope">
          <el-button size="mini" @click="editStoresShowTypeImgClick(scope.row)">编辑</el-button>
          <el-button  size="mini" type="primary" @click="listStoresShowImgClick(scope.row)" >详情</el-button>

          <el-button size="mini"  type="info" @click="deleteUser(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <el-drawer :wrapperClosable= false
            class="normalDrawer"
            :title="title"
            direction="ltr"
            size="30%"
            :visible.sync="showDrawerGG"
           
            >
            <div class="drawerForm">
                <el-form :model="ruleFormGG" ref="ruleFormGG"  label-width="130px" label-position="right">
            
                    <el-form-item label="图片标题：" prop="ImgTitle">
                        <el-input v-model="ruleFormGG.ImgTitle" size="mini" placeholder="请输入图片标题" style="width:200px"></el-input>
                    </el-form-item>
                 
                </el-form> 
            <div class="demo-drawer__footer flex-r-x"  style="width:30%">
                        <el-button size="small" @click="showDrawerGG = false">取消</el-button>
                        <el-button
                        style="margin-right:20px"
                            size="small"
                            type="primary"
                            class="title"
                            @click="onSendgg('ruleFormGG')"
                            >保存</el-button
                            >
                    </div>
            </div>
        </el-drawer>
         <el-drawer 
            class="normalDrawer"
            title="图片详情"
            direction="ltr"
            size="50%"
            :visible.sync="showRightDrawer3"
            :wrapperClosable="false"
            >
            <div class="drawerForm">
                <el-form   label-width="70px" label-position="right">
            
                    <el-form-item label="图片：" prop="ImgUrl">
                       <el-upload
                            :action="URL"
                            list-type="picture-card"
                            :file-list="fileList"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove1"
                            :http-request="imageChange"
                            :before-upload="beforeUp"
                            >
                            <!-- :on-success="handleAvatarSuccess" -->
                            <i class="el-icon-plus"></i>
                        </el-upload>
                     </el-form-item>
                        <!-- <el-button type="primary" size="medium" @click="onSendgg1()">保 存</el-button> -->
                        <!-- <el-button @click="showRightDrawer3 = false">取 消</el-button> -->
         
                </el-form>
            </div>
        </el-drawer>
        <el-dialog  class="normalDrawer"
             direction="ltr"
          :visible.sync="dialogVisible1">
              <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
 </div>

</template>
<script>
import { baseUrl } from "../../config/env.js";
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
import * as imageConversion from 'image-conversion'
export default {
  data() {
    return {
        dialogVisible1:false,
        dialogImageUrl:'',
   quanxian:false,
   quanxian1:false,
    imgVisible:false,
    DianList:[],
    URL: baseUrl + "upload_images.aspx",
    SelectStoresID:this.$route.params.id,
      direction: "ltr",
      cropperModel:false,
      passShow:false,
      token:localStorage.getItem("token"),
      money:'',
      timer:'',
      cropperName:'',
      input:'',
      timer:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      tableData:[],
      Pwd:'',
      props: {
          children: 'listsub',
          label: 'Name'
      },
      RoleID:'',
      editForm: {
        LoginName:"",
        Role:[],
        Phone:"",
        Name:"",
        pwd:"",
        money:"",
        ShopName:"",
        HeadUrl:'',
        Email:'',
        Note:'',
        token: localStorage.getItem('token')
      },
      personList:[],
      roleList:[],
      ruleFormGG:{
        StoresImgID:"",
            ImgTitle:" ",
            ImgUrl:"",
            StoresID:this.selectedStore,
      },
      // rules表单验证

      rules: {
        // Role:[{type: 'array', required: true, message: '请选择所属角色', trigger: 'change' }],
        Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        Pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      ruleFormimg:{},
      showRightDrawer3:false,
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      rulesGG:[],

      showDrawerGG:false,
      isedittype:false,
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      fileList:[],
      GoodsList:[],
      // 分页参数
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    this.getList()

      // this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      beforeUp(file){
                const isLt2M = file.size / 1024 / 1024 < 10;
                
                    if (!isLt2M) {
                        this.$message.error('上传头像图片大小不能超过 10MB!');
                        return(false)
                } 


                return new Promise((resolve, reject) => {
                
                        console.log('压缩前', file) // 压缩到400KB,大于400KB的图片都会进行压缩，小于则不会
                        imageConversion.compressAccurately(file, 1000).then(res => { // console.log(res)
                        res = new File([res], file.name, { type: res.type, lastModified: Date.now() })
                        console.log('压缩后', res)
                        resolve(res)
                        })
                    

                      
                })
            },
      imageChange(param,type){
      let formData = new FormData();
        var URL = baseUrl + "upload_images.aspx";
        formData.append('file',param.file)
        formData.append("token",localStorage.getItem("token"));
       this.$axios.post(URL,formData).then((res) =>{
         
            if(res.data.orsuccess == 1){
        
                this.addStoresShowImg(res.data.url);
                // this.fileList.push(res.data.url)
         }
       })
        
      },
      addStoresShowImg(url){
            var data = { 
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            TypeID:this.ruleFormimg.TypeID,
            ImgUrl:url
            }
        var that = this
        this.ajax('addStoresShowImg.aspx',JSON.stringify(data),"POST",function(res){
                if(res.orsuccess == '1'){
                    that.$message({ type: "success", message: res.Msg ,duration:1000});
                    that.getListStoresShowImg()
                }
            })
      },
listStoresShowImgClick(row){
        // this.currentPage4 = 1;
        //  this.offset4 = 1;
    this.ruleFormimg.TypeID = row.ID;
    this.getListStoresShowImg();
}, getListStoresShowImg(){
     var data = { 
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            TypeID: this.ruleFormimg.TypeID
        }
        var that = this
        this.ajax('getListStoresShowImg.aspx',JSON.stringify(data),"POST",function(res){
                if(res.orsuccess == '1'){
                    that.GoodsList = res.data;
                     that.fileList =[];
                      for (let i = 0; i < that.GoodsList.length; i++) {
                        const element = that.GoodsList[i];
                        that.fileList.push({url:element.ImgUrl,uid: element.ID,status:"success"})
                    }
                    that.showRightDrawer3= true;
                }
            })
        },
 handleRemove(file, fileList) {
                this.formData.img = fileList;
             },
             handlePictureCardPreview(file) {
                 this.dialogImageUrl = file.url;
                   this.dialogVisible1 = true;
             }, 
            //  handleAvatarSuccess(res, file) {
         
            //   if(res.orsuccess=='1'){
            //     this.ruleFormimg.ImgUrl =res.url;
            //         this.addStoresShowImg();

            //   }
            //  }, 
             handleRemove1(file, fileList) {
                 if (file && file.status==="success") {

               this.$confirm('确定删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                    this.delStoresShowImg(file.uid)
                    }).catch(() => {
                        this.fileList =[];
                        this.getListStoresShowImg();

                    });
                 }
    },
delStoresShowImg(StoresShowImgID){
      var data = { 
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
             ID:StoresShowImgID
            }
        var that = this
        this.ajax('delStoresShowImg.aspx',JSON.stringify(data),"POST",function(res){
                if(res.orsuccess == '1'){
                    that.$message({ type: "success", message: res.Msg ,duration:1000});
                    that.getListStoresShowImg()
                }
            })
},
      editStoresShowTypeImgClick(row){
          this.title = '修改照片墙'
                this.ruleFormGG.StoresImgID=row.ID;
                this.ruleFormGG.StoresID=this.selectedStore;
                this.ruleFormGG.ImgTitle=row.ImgTitle;
                this.ruleFormGG.ImgUrl=row.ImgUrl;
                this.currentBaseImg=row.ImgUrl;
                this.isedittype= true;
                this.showDrawerGG = true; 
    },

    onSendgg(formName){
  
        if(this.ruleFormGG.ImgTitle == ' '){
           console.log('111')
            this.$message({ type: "error", message: "请输入标题" ,duration:1000});
            return;
        }
    if(this.isedittype == false){
 var data = { 
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            ImgTitle:this.ruleFormGG.ImgTitle
  
        
        }
        var that = this
        this.ajax('addStoresShowTypeImg.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "添加成功",duration:2000,
              });
        that.showDrawerGG = false
              that.getList()
              //  that.provinceList = res.data
            }

        })
    } else {  
        var data = { 
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            ImgTitle:this.ruleFormGG.ImgTitle,
            StoresImgID:this.ruleFormGG.StoresImgID,
            ImgUrl:this.ruleFormGG.ImgUrl,
            currentBaseImg:this.ruleFormGG.ImgUrl
        }
        var that = this
        this.ajax('editStoresShowTypeImg.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });
        that.showDrawerGG = false
              that.getList()
              //  that.provinceList = res.data
            }

        })
    }
         
    },
      tosetting(){
         this.$router.push({ path: '/setting/setting'})
      },
      changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      this.getList()

    },
    addShowImgClick(){
        this.ruleFormGG = {
            StoresImgID:"",
            ImgTitle:" ",
            ImgUrl:"",
            StoresID:this.selectedStore,
        }
        this.title = '添加照片墙'
        this.currentBaseImg = "";
        this.isedittype =false;
        this.showDrawerGG = true;

    },




                 
    deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            StoresImgID:row.ID
        
        }
        var that = this
        this.ajax('delStoresShowTypeImg.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
 
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },
    change(event){
        console.log(event)
        console.log(this.Role)
    },
    uploadPicture(name) {
        this.timer = new Date().getTime()
      this.cropperName = name;
      this.cropperModel = true;
    },
     handleUploadSuccess(data) {
          this.cropperModel = false
          this.editForm.HeadUrl = data.url
 
  },

    getList(){

    //  this.tableLoading = true
       var data = { 
           SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,

      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListStoresShowTypeImg.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                that.pageparm.total = res.allcount

                 loading.close();
          } 

      })
  
    },

    handlePassword(row){
      this.editForm.ManageLoginID = row.ID
      this.Pwd = ''
      this.passShow = true

    },
    handleChong(row){
      this.editForm.ManageLoginID = row.ID
      this.editForm.money = row.money
       this.chongShow = true
      this.money = ''
    },
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit(row) {
       var that = this
      if (row != undefined && row != 'undefined') {
        this.title = '修改操作员'

        that.editForm = row
        if(row.Role != 0){
            
          const list = this.editForm.Role.split(",")
          const list1 = []
          list.forEach(item => {
              this.roleList.forEach(items => {
                   if(item == items.RType)
                           list1.push(items.RoleName)
                })
            })
            that.editForm.Role = list1
    
        } else {
          that.editForm.Role = []
        }
       
      } else {
        this.title = '添加操作员'
        this.editForm = {
          Phone:"",
          Name:"",
          Pwd:'',
          HeadUrl:'',
          Email:'',
          Note:'',
          Role:[],
        }
      }
      this.editFormVisible = true
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      

         var list = []
         if(this.editForm.Role.length >0){
            this.editForm.Role.forEach(item => {
                    this.roleList.forEach(items => {
                          if(item == items.RoleName)
                              list = list + items.RType +','
                      })
            })
            list=list.substr(0,list.length-1)
            console.log(list)
         }
        
      this.$refs[editData].validate(valid => {
        if (valid) {
          var data =this.editForm
            data.token=localStorage.getItem("token")
            data.StoresID=localStorage.getItem("StoresID")

              if(list.length == 0){
                  data.Role = ''
              } else {
                  data.Role = list
              }
              
              data.SelectStoresID = this.SelectStoresID
              var that = this
            if(this.title == '添加操作员'){
                let selectNodes = this.$refs.tree1.getCheckedNodes();
                let NodeIDs = [];
                selectNodes.forEach((item,index) =>{
                    NodeIDs.push(item.ID);
                })
                let halfSelectNodes = this.$refs.tree1.getHalfCheckedNodes();
                halfSelectNodes.forEach(item=>{
                    NodeIDs.push(item.ID)
                })
        let allStr = NodeIDs.join(",");
                data.StaffIDs = allStr
                this.ajax('addLogin.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })

            }else {
                data.LoginID=  this.editForm.ID
                 this.ajax('editLogin.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                        });
                        that.editFormVisible = false
                        that.getList()
                     }

                })
            }
        } else {
          return false
        }
      })
    
    
    },
handlejin(row){
 this.$confirm("确定要禁用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          LoginID:row.ID,
          Isdisable:1
        }
        var that = this
        this.ajax('editLoginisable.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "禁用成功",duration:2000,
              });
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
         
        });
   
},
handlejie(row){
 this.$confirm("确定要启用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          LoginID:row.ID,
          Isdisable:0
        }
        var that = this
        this.ajax('editLoginisable.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "启用成功",duration:2000,
              });
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
       
        });
   
},
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
      this.getList()
      this.editForm = {
          Phone:"",
          Name:"",
          Pwd:'',
          HeadUrl:'',
          Email:'',
          Note:'',
          Role:[],
        }
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/photo/photo.vue